import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  getWorksheet,
  saveWorksheet,
  postWorksheetTag,
  deleteWorksheetTag,
} from "../../../api/worksheets.service";
import { UploadIcon } from "../../../assets/icons/index";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import { IStandard } from "../../../model/interface/standard";
import { IWorksheet } from "../../../model/interface/worksheet";
import constant from "../../../utils/constant";
import Breadcrumb from "../../shared/common/breadcrumb";
import LinkedStandard from "../../shared/common/linkedStandard";
import Loader from "../../shared/loader/loader";
import WorksheetFile from "./worksheetFilePreview";
import WorksheetStandard from "./worksheetStandard";
import WorksheetTags from "./worksheetTags";
import { IlinkedStandard } from "../../../model/interface/linkedStandard";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { useNumericParam } from "../../../utils/useNumericParam";

const ManageWorksheet = (props: any) => {
  const defaultData: IWorksheet = {
    worksheetId: 0,
    standardName: "",
    standardCode: "",
    title: "",
    description: "",
    spanishTitle: "",
    spanishDescription: "",
    standardId: 0,
    isApproved: true,
    isActive: true,
    userId: props.profile?.userId,
    domainId: 0,
    subjectId: 0,
    contentAreaId: 0,
    worksheetTags: [],
    gradeLevelId: "",
    gradeLevel: "",
  };
  const defaultValue: ISelectElement = { label: "", value: "0" };
  const [worksheet, setWorksheet] = useState<IWorksheet>(defaultData);
  const [contentAreas, setContentAreas] = useState<ISelectElement[]>([]);
  const [subjects, setSubjects] = useState<ISelectElement[]>([]);
  const [domains, setDomains] = useState<ISelectElement[]>([]);
  const [standards, setStandards] = useState<ISelectElement[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedStandard, setSelectedStandard] =
    useState<ISelectElement>(defaultValue);
  const [selectedContent, setSelectedContent] = useState<ISelectElement>();
  const [selectedSubject, setSelectedSubject] =
    useState<ISelectElement>(defaultValue);
  const [selectedDomain, setSelectedDomain] =
    useState<ISelectElement>(defaultValue);
  const [selectedWorksheetFile, setSelectedWorksheetFile] = useState<any>();
  const [selectedWorksheetKeyFile, setSelectedWorksheetKeyFile] =
    useState<any>();
  const [isKeyNotRequired, setIsKeyNotRequired] = useState<boolean>(false);
  const [selectedLanguage, setSelectedLanguage] = useState<number>(
    constant.ENGLISH
  );
  const [selectedTagIds, setSelectedTagIds] = useState<Array<number>>([]);
  const [showLinkedStandards, setShowLinkedStandards] =
    useState<boolean>(false);
  const [linkedStandards, setLinkedStandards] = useState<IlinkedStandard[]>([]);
  const location = useLocation();
  const parameters = location.state as any;
  const navigate = useNavigate();
  const id = useNumericParam("id");
  const worksheetId = useNumericParam("worksheetId");
  type tabName = "WorksheetFile" | "WorksheetFileKey" | "Standards" | "Tags";
  const [activeTab, setActiveTab] = useState<tabName>("WorksheetFile");
  const activeTabClass =
    "text-gray-900 topBorder bg-white border border-b-0 group relative min-w-0 flex-1 mb-0 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 dark:hover:bg-gray-700 focus:z-10";
  const inActiveTabClass =
    "text-gray-500 hover:text-gray-700 group relative min-w-0 flex-1 overflow-hidden mb-0 py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10";
  const [isSaving, setIsSaving] = useState<boolean>(false);
  useEffect(() => {
    if (id) {
      bindWorksheet(id);
    } else {
      bindContentAreas();
    }
  }, []);

  useEffect(() => {
    if (
      parameters &&
      parameters.autoFillData &&
      Object.keys(parameters.autoFillData).length
    ) {
      if (parameters.autoFillData.contentId) {
        setSelectedContent({
          label: parameters.autoFillData.contentName,
          value: parameters.autoFillData.contentId,
        });
      }

      if (parameters.autoFillData.subjectId) {
        setSelectedSubject({
          label: parameters.autoFillData.subjectName,
          value: parameters.autoFillData.subjectId,
        });
      }

      if (parameters.autoFillData.domainId) {
        setSelectedDomain({
          label: parameters.autoFillData.domainName,
          value: parameters.autoFillData.domainId,
        });
      }

      if (parameters.autoFillData.standardId) {
        setSelectedStandard({
          label: parameters.autoFillData.name,
          value: parameters.autoFillData.standardId,
        });
      }
    }
  }, []);

  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Worksheet", url: constant.WORKSHEETS },
      {
        name: id ? "Edit Worksheet" : "Add Worksheet",
        url: "",
      },
    ];

    if (worksheetId && id) {
      items.push({
        name: "",
        url: "",
        objectId: id?.toString(),
      });
    }

    return items;
  };
  async function handleShowLinkedStandardsConfimation(standardId: number) {
    const service = await import("../../../api/standardLinking.service");
    service.getAssociatedStandards(standardId).then((response) => {
      if (response && response.data.length > 0) {
        setShowLinkedStandards(true);
        setLinkedStandards(response.data);
      } else handleRedirect();
    });
  }
  const handleRedirect = () => {
    navigate(
      parameters?.autoFillData
        ? constant.EDITSTANDARD.replace(
            ":id",
            parameters?.autoFillData?.standardId
          )
        : constant.WORKSHEETS,
      { state: { fromWorksheetPage: true } }
    );
  };
  async function bindContentAreas(contentAreaId?) {
    const service = await import("../../../api/contentArea.service");
    service.getContentArea().then((response) => {
      const result = response.data.data;
      const contentAreaData = result.map((item) => {
        return { label: item.name, value: item.contentAreaId };
      });
      setContentAreas(contentAreaData);
      if (parameters?.autoFillData?.contentId) {
        setSelectedContent({
          label: parameters.autoFillData.contentName,
          value: parameters.autoFillData.contentId,
        });
      }
      if (contentAreaId) {
        const selectedContentArea = contentAreaData.find((t) => {
          return t.value === contentAreaId;
        });
        setSelectedContent(selectedContentArea);
      }
    });
  }

  async function bindSubjects(
    selectedItem?: ISelectElement,
    subjectId?,
    contentAreaId?
  ) {
    const contentId =
      selectedItem?.value == "0" ? contentAreaId : selectedItem?.value;

    const service = await import("../../../api/subject.service");
    service
      .getSubjectAllByContent(parseInt(contentId || 0))
      .then((response) => {
        const result = response.data;
        const subjectsData = result.map((item) => {
          return { label: item.subjectName, value: item.subjectId };
        });

        setSubjects(subjectsData);
        if (subjectId) {
          const selectedSubject = subjectsData.find((t) => {
            return t.value === subjectId;
          });
          setSelectedSubject(selectedSubject);
        }
      });
  }

  async function bindDomains(
    selectedItem?: ISelectElement,
    domainId?,
    subject?
  ) {
    const subjectId =
      selectedItem?.value == "0" ? subject : selectedItem?.value;
    const service = await import("../../../api/domain.service");
    service
      .getAllDomainsBySubject(parseInt(subjectId || 0))
      .then((response) => {
        const result = response.data.data;
        const domainsData = result.map((item) => {
          return { label: item.name, value: item.domainId };
        });
        setDomains(domainsData);
        if (domainId) {
          const selectedDomain = domainsData.find((t) => {
            return t.value === domainId;
          });
          setSelectedDomain(selectedDomain);
        }
      });
  }

  async function bindStandards(
    selectedItem?: ISelectElement,
    standardId?,
    domainId?,
    subjectId?,
    contentAreaId?
  ) {
    setLoading(true);
    const standard: IStandard = {
      name: "",
      contentAreaId:
        selectedContent?.value == undefined
          ? contentAreaId
          : selectedContent?.value,
      subjectId:
        selectedSubject?.value == "0" ? subjectId : selectedSubject.value,
      domainId: selectedItem?.value == "0" ? domainId : selectedItem?.value,
      code: "",
      isActive: true,
      description: "",
      loadOrder: 0,
      pageSize: 9999 * 9999,
      pageNumber: 1,
      standardId: 0,
      orderbyColumn: "asc",
      sortDir: "name",
    };
    const service = await import("../../../api/standard.service");
    service.getStandards(standard).then((response: any) => {
      if (response.data.data.length > 0) {
        const standards = response.data.data.map((standard) => {
          return {
            label: `[${standard.code}] ${standard.name}`,
            value: standard.standardId,
          };
        });

        setStandards(standards);
        if (standardId) {
          const selectedStandard = standards.find((t) => {
            return t.value === standardId;
          });
          setSelectedStandard(selectedStandard);
        }
      }
      setLoading(false);
    });
  }

  const bindWorksheet = async (worksheetId) => {
    setLoading(true);
    let response: any = getWorksheet(worksheetId);
    response = (await response).data;
    setLoading(false);
    if (response) {
      setWorksheet(response);
      bindContentAreas(response?.contentAreaId);
      bindSubjects(defaultValue, response.subjectId, response.contentAreaId);
      bindDomains(defaultValue, response.domainId, response.subjectId);
      bindStandards(
        selectedStandard,
        response.standardId,
        response.domainId,
        response.subjectId,
        response.contentAreaId
      );
      bindWorksheetTags(response.worksheetTags);
    } else {
      setWorksheet(defaultData);
    }
  };

  const bindWorksheetTags = (tags) => {
    if (tags && tags.length > 0) {
      const tagIds = tags.map((tag) => tag.tagId);
      setSelectedTagIds(tagIds);
    }
  };

  function handleContentAreaChange(selectedItem: any) {
    setSelectedContent(selectedItem);
    bindSubjects(selectedItem);
  }

  function handleSubjectChange(selectedItem: any) {
    setSelectedSubject(selectedItem);
    bindDomains(selectedItem);
  }

  function handleDomainChange(selectedItem: any) {
    setSelectedDomain(selectedItem);
    bindStandards(selectedItem);
  }

  function handleStandardChange(selectedItem: any) {
    setSelectedStandard(selectedItem);
    if (selectedItem.value) {
      setWorksheet({
        ...worksheet,
        standardId: parseInt(selectedItem.value) || 0,
      });
    }
  }

  function handleFilterChange(e: any, type) {
    if (type == "StandardId") {
      setWorksheet({
        ...worksheet,
        standardId: e.target.value || 0,
      });
    } else if (type == "Title") {
      if (selectedLanguage == constant.ENGLISH) {
        setWorksheet({
          ...worksheet,
          title: e.target.value || "",
        });
      } else {
        setWorksheet({
          ...worksheet,
          spanishTitle: e.target.value || "",
        });
      }
    } else if (type == "Description") {
      if (selectedLanguage == constant.ENGLISH) {
        setWorksheet({
          ...worksheet,
          description: e.target.value || "",
        });
      } else {
        setWorksheet({
          ...worksheet,
          spanishDescription: e.target.value || "",
        });
      }
    }
  }

  const onWorksheetFileChange = (event) => {
    if (
      event?.target?.files?.length &&
      event?.target?.files[0]?.name
        ?.split(".")
        ?.pop()
        .toLowerCase()
        .includes("pdf")
    ) {
      setSelectedWorksheetFile(event.target.files[0]);
    } else {
      toast.warning("Invalid worksheet file, It should be pdf");
    }
  };

  const onWorksheetKeyFileChange = (event) => {
    if (
      event?.target?.files?.length &&
      event?.target?.files[0]?.name
        ?.split(".")
        ?.pop()
        .toLowerCase()
        .includes("pdf")
    ) {
      setSelectedWorksheetKeyFile(event.target.files[0]);
    } else {
      toast.warning("Invalid worksheet key file, It should be pdf");
    }
  };

  const handleIsKeyRequired = () => {
    setIsKeyNotRequired(!isKeyNotRequired);
  };

  const saveHandler = async (e) => {
    e.preventDefault();
    if (isSaving) return;
    setIsSaving(true);

    if (!worksheet?.worksheetFilePath && !selectedWorksheetFile) {
      toast.warning("Please select a worksheet");
    } else {
      setLoading(true);
      const formData = new FormData();
      formData.append("worksheetFile", selectedWorksheetFile);
      formData.append("worksheetKeyFile", selectedWorksheetKeyFile);
      formData.append("title", worksheet.title);
      formData.append("description", worksheet.description);
      formData.append("spanishTitle", worksheet.spanishTitle);
      formData.append("spanishDescription", worksheet.spanishDescription);
      formData.append("StandardId", selectedStandard?.value?.toString());
      formData.append(
        "isKeyRequired",
        isKeyNotRequired == true ? "false" : "true"
      );
      formData.append(
        "isApproved",
        worksheet.isApproved?.toString() === "false" ? "false" : "true"
      );
      formData.append("userId", props.profile?.userId);
      if (id) {
        formData.append("worksheetId", id?.toString());
        formData.append("worksheetFilePath", worksheet.worksheetFilePath ?? "");
        formData.append(
          "worksheetKeyFilePath",
          worksheet.worksheetKeyFilePath ?? ""
        );
      }

      const response = await saveWorksheet(formData);
      setLoading(false);

      if (id) {
        // Refresh the page when editing the worksheet
        window.location.reload();
      } else {
        navigate(constant.WORKSHEETEDIT.replace(":id", response.data));
      }
    }

    setIsSaving(false);
  };

  const onToggleLanguage = (value) => {
    setSelectedLanguage(value);
  };

  const downloadWS = (id?, worksheet?) => {
    if (worksheet) {
      window.location.assign(
        `${constant.DOWNLOAD_WORKSHEET}id=${id}&worksheetFile=${worksheet}`
      );
    } else {
      toast.warning("File not found");
    }
  };

  const handleSaveTags = (tags) => {
    const selectedTagIds = tags
      .filter((tag) => tag.selected === true)
      .map((tag) => tag.tagId);

    const tag = {
      worksheetId: Number(id),
      tagId: selectedTagIds,
    };
    setSelectedTagIds(selectedTagIds);
    postWorksheetTag(tag);
  };

  const handleRemoveTag = (allTags, tag) => {
    const selectedTagIds = allTags
      .filter((t) => t.selected === true)
      .map((t) => t.tagId);

    const tagParam = {
      worksheetId: Number(id),
      tagId: tag.tagId,
    };
    setSelectedTagIds(selectedTagIds);
    deleteWorksheetTag(tagParam);
  };

  return (
    <AllowedTo
      perform={[Permissions.worksheet_create, Permissions.worksheet_modify]}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 overflow-y-auto mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                {id ? "Edit Worksheet " : "Add Worksheet"}
              </h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />
            <div className="mt-6 w-full">
              <div className="flex space-x-8">
                <div className="w-1/4 border rounded-lg shadow">
                  <form onSubmit={saveHandler}>
                    <div className="py-6 px-4">
                      <div className="flex justify-end">
                        <div className="inline-block border text-sm border-gray-300 overflow-hidden rounded-md mb-4">
                          <button
                            type="button"
                            onClick={() => {
                              onToggleLanguage(constant.ENGLISH);
                            }}
                          >
                            <span
                              className={`${
                                selectedLanguage === constant.ENGLISH
                                  ? "bg-primary-color text-white"
                                  : "bg-white text-gray-400"
                              } inline-block dark:text-white w-20 py-0.5 text-center cursor-pointer hover:opacity-80`}
                            >
                              English
                            </span>
                          </button>

                          <button
                            type="button"
                            onClick={() => {
                              onToggleLanguage(constant.SPANISH);
                            }}
                          >
                            <span
                              className={`${
                                selectedLanguage === constant.SPANISH
                                  ? "bg-primary-color text-white"
                                  : "bg-white text-gray-400"
                              }  w-20 py-0.5 inline-block text-center  cursor-pointer hover:text-gray-500 dark:hover:text-gray-400`}
                            >
                              Spanish
                            </span>
                          </button>
                        </div>
                      </div>

                      <div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm col-span-1 flex items-center ">
                            <label className="font-medium text-gray-700">
                              Title
                            </label>
                          </div>
                          <div>
                            <input
                              id="name"
                              defaultValue={
                                selectedLanguage == constant.ENGLISH
                                  ? worksheet?.title
                                  : worksheet?.spanishTitle || ""
                              }
                              type="text"
                              autoComplete="off"
                              className="mt-1 w-full block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                              onChange={(e) => {
                                handleFilterChange(e, "Title");
                              }}
                            />
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm col-span-1 flex items-center ">
                            <label className="font-medium text-gray-700">
                              Description
                            </label>
                          </div>
                          <div>
                            <input
                              id="code"
                              defaultValue={
                                selectedLanguage == constant.ENGLISH
                                  ? worksheet?.description
                                  : worksheet?.spanishDescription || ""
                              }
                              autoComplete="off"
                              type="text"
                              className="mt-1 w-full block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                              onChange={(e) => {
                                handleFilterChange(e, "Description");
                              }}
                            />
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm col-span-1 flex items-center ">
                            <label className="font-medium text-gray-700">
                              Content Area
                            </label>
                          </div>
                          <div className="mt-1">
                            <Select
                              value={selectedContent}
                              onChange={handleContentAreaChange}
                              options={contentAreas}
                              className="text-gray-900 cursor-default select-none relative py-2"
                              isSearchable={true}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#B3B3B3",
                                  primary: "#041E42",
                                },
                              })}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  background:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#1A1C23"
                                      : "white",
                                  borderColor:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6B7280"
                                      : "#D1D5DB",
                                  borderWidth: "1px",
                                  "&:hover": {
                                    borderColor:
                                      state.isFocused &&
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6b7280"
                                        : state.isFocused
                                        ? "#4c5563"
                                        : "",
                                  },
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "#374051",
                                }),
                                input: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "",
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm col-span-1 flex items-center ">
                            <label className="font-medium text-gray-700">
                              Subject
                            </label>
                          </div>
                          <div className="mt-1">
                            <Select
                              value={selectedSubject}
                              onChange={handleSubjectChange}
                              options={subjects}
                              className="text-gray-900 cursor-default select-none relative py-2"
                              isSearchable={true}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#B3B3B3",
                                  primary: "#041E42",
                                },
                              })}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  background:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#1A1C23"
                                      : "white",
                                  borderColor:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6B7280"
                                      : "#D1D5DB",
                                  borderWidth: "1px",
                                  "&:hover": {
                                    borderColor:
                                      state.isFocused &&
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6b7280"
                                        : state.isFocused
                                        ? "#4c5563"
                                        : "",
                                  },
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "#374051",
                                }),
                                input: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "",
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm col-span-1flex items-center ">
                            <label className="font-medium text-gray-700">
                              Domain
                            </label>
                          </div>
                          <div className="mt-1">
                            <Select
                              value={selectedDomain}
                              onChange={handleDomainChange}
                              options={domains}
                              className="text-gray-900 cursor-default select-none relative py-2"
                              isSearchable={true}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#B3B3B3",
                                  primary: "#041E42",
                                },
                              })}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  background:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#1A1C23"
                                      : "white",
                                  borderColor:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6B7280"
                                      : "#D1D5DB",
                                  borderWidth: "1px",
                                  "&:hover": {
                                    borderColor:
                                      state.isFocused &&
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6b7280"
                                        : state.isFocused
                                        ? "#4c5563"
                                        : "",
                                  },
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "#374051",
                                }),
                                input: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "",
                                }),
                              }}
                            />
                          </div>
                        </div>
                        <div className="grid grid-cols-1 mt-5">
                          <div className="text-sm col-span-1 flex items-center ">
                            <label className="font-medium text-gray-700">
                              Standard
                            </label>
                          </div>
                          <div className="mt-1">
                            <Select
                              value={selectedStandard}
                              onChange={handleStandardChange}
                              options={standards}
                              className="text-gray-900 cursor-default select-none relative py-2"
                              isSearchable={true}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#B3B3B3",
                                  primary: "#041E42",
                                },
                              })}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  background:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#1A1C23"
                                      : "white",
                                  borderColor:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "#6B7280"
                                      : "#D1D5DB",
                                  borderWidth: "1px",
                                  "&:hover": {
                                    borderColor:
                                      state.isFocused &&
                                      document.getElementsByClassName("dark")
                                        ?.length > 0
                                        ? "#6b7280"
                                        : state.isFocused
                                        ? "#4c5563"
                                        : "",
                                  },
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "#374051",
                                }),
                                input: (base) => ({
                                  ...base,
                                  color:
                                    document.getElementsByClassName("dark")
                                      ?.length > 0
                                      ? "white"
                                      : "",
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="flex justify-between items-center space-x-4 mt-5">
                          <div className="border p-2 bg-gray-50 cursor-pointer group">
                            <label className="relative cursor-pointer rounded-lg font-medium ">
                              <div className="flex">
                                <UploadIcon className="w-6 m-auto text-gray-500 group-hover:text-blue-500 "></UploadIcon>
                                <span className="text-blue-700 group-hover:text-blue-500 ml-2">
                                  Upload worksheet
                                </span>
                              </div>
                              <input
                                type="file"
                                onChange={onWorksheetFileChange}
                                name="worksheetFile"
                                className="sr-only"
                              />
                            </label>
                          </div>
                          <div
                            className={`border p-2 bg-gray-50 group ${
                              !isKeyNotRequired ? "bg-gray-50" : "bg-gray-200"
                            }`}
                          >
                            <label
                              className={`relative  rounded-lg font-medium ${
                                !isKeyNotRequired
                                  ? "cursor-pointer"
                                  : "cursor-not-allowed"
                              }`}
                            >
                              <div className="flex">
                                <UploadIcon className="w-6 m-auto text-gray-500 group-hover:text-blue-500"></UploadIcon>
                                <span className="text-blue-700 group-hover:text-blue-500 ml-2">
                                  Upload worksheet key
                                </span>
                              </div>
                              <input
                                disabled={isKeyNotRequired}
                                type="file"
                                onChange={onWorksheetKeyFileChange}
                                name="worksheetKeyFile"
                                className="sr-only"
                              />
                            </label>
                          </div>
                        </div>

                        <div className="grid grid-cols-12 mt-1">
                          <div className="col-span-6"></div>
                          <div className="col-span-6 flex justify-end">
                            <div className="text-sm mt-3">
                              <input
                                type="checkbox"
                                id="isKeyRequired"
                                name="isKeyRequired"
                                value="isKeyRequired"
                                className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                                onChange={handleIsKeyRequired}
                              />

                              <label className="ml-2 font-medium text-gray-700">
                                Key not required
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="flex justify-end mt-8 items-center border-t ">
                          <button
                            type="submit"
                            className="inline-flex items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                          >
                            {worksheet.worksheetId ? "Update " : "Save"}
                          </button>
                          <Link to={constant.WORKSHEETS} className="ml-2">
                            <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                              Cancel
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="w-3/4">
                  {id && (
                    <Fragment>
                      <div className="flex items-center justify-between bg-gray-100 w-full">
                        <div className="flex">
                          <button onClick={() => setActiveTab("WorksheetFile")}>
                            <h2
                              className={
                                activeTab === "WorksheetFile"
                                  ? activeTabClass
                                  : inActiveTabClass
                              }
                            >
                              Worksheet Preview
                            </h2>
                          </button>
                          <button
                            onClick={() => setActiveTab("WorksheetFileKey")}
                          >
                            <h2
                              className={
                                activeTab === "WorksheetFileKey"
                                  ? activeTabClass
                                  : inActiveTabClass
                              }
                            >
                              Worksheet Key Preview
                            </h2>
                          </button>
                          <button onClick={() => setActiveTab("Standards")}>
                            <h2
                              className={
                                activeTab === "Standards"
                                  ? activeTabClass
                                  : inActiveTabClass
                              }
                            >
                              Worksheet Standards
                            </h2>
                          </button>
                          <button onClick={() => setActiveTab("Tags")}>
                            <h2
                              className={
                                activeTab === "Tags"
                                  ? activeTabClass
                                  : inActiveTabClass
                              }
                            >
                              Tags
                            </h2>
                          </button>
                        </div>
                      </div>
                      {activeTab === "WorksheetFile" && (
                        <WorksheetFile
                          worksheetData={worksheet}
                          previewData={{
                            title: worksheet.worksheetFilePath
                              ? "Worksheet File Preview"
                              : "No Worksheet file attached",
                            previewType: "file",
                          }}
                          downloadWS={downloadWS}
                          filePath={worksheet?.worksheetFilePath}
                        />
                      )}

                      {activeTab === "WorksheetFileKey" && (
                        <WorksheetFile
                          worksheetData={worksheet}
                          previewData={{
                            title: worksheet.worksheetKeyFilePath
                              ? "Worksheet File Key Preview"
                              : "No worksheet key file attached",
                            previewType: "key",
                          }}
                          downloadWS={downloadWS}
                          filePath={worksheet?.worksheetKeyFilePath}
                        />
                      )}
                      {activeTab === "Standards" && (
                        <WorksheetStandard worksheetData={worksheet} />
                      )}
                      {activeTab === "Tags" && (
                        <WorksheetTags
                          worksheetData={worksheet}
                          handleSaveTags={handleSaveTags}
                          handleRemoveTag={handleRemoveTag}
                          selectedTagIds={selectedTagIds}
                        />
                      )}
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showLinkedStandards && linkedStandards && linkedStandards.length > 0 && (
        <LinkedStandard
          standardId={selectedStandard?.value}
          title={"Linked Standards"}
          redirectUrl={
            parameters?.autoFillData
              ? constant.EDITSTANDARD.replace(
                  ":id",
                  parameters?.autoFillData?.standardId
                )
              : constant.WORKSHEETS
          }
          confirmAction={handleShowLinkedStandardsConfimation}
          buttonText={"Ok"}
          fromPageName={constant.ADDWORKSHEET}
          linkedStandardsData={linkedStandards}
        />
      )}
    </AllowedTo>
  );
};
const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(ManageWorksheet);
